// extracted by mini-css-extract-plugin
export default {"btn-close":"AppModals_btn-close__UossH","fenceDesign":"AppModals_fenceDesign__-C3ya"};